// extracted by mini-css-extract-plugin
export default {"ticket":"wBOkmA","discount":"X8mwIm","row":"s9VUT6","name":"q6uXno","singlePrice":"QP_TnG","price":"vJdBV8","quantity":"qyybLS","total":"lHwY1v","priceItem":"T6ssyV"};